import React, { useContext, useState, useRef, useEffect } from 'react'
import { DarkModeContext } from '../../global/Theme'
import './index.sass'
import { Monetization } from '../post';

import 'emoji-mart/css/emoji-mart.css'
import { Picker } from 'emoji-mart'

export default function ChatInput({channel, isDesktopModalVisible, uploadState, handleSend, handleMediaSend, handleDesktopModalToggle }) {
    const { isDark } = useContext(DarkModeContext);
    const msgRef = useRef()
    const videoRef = useRef()

    const [msg, setMsg] = useState("")
    const [image, setImage] = useState("")
    const [media, setMedia] = useState(null);
    const [monetization, setMonitization] = useState(-1)
    const [price, setPrice] = useState(0)
    const [isEmojiVisible, setIsEmojiVisible] = useState(false)
   

    const sleep = async (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms))
    }

    const simulateEnter = () => {
        var simulatedEvent = new KeyboardEvent("keypress", { keyCode: 13, which: 13 });
        handleKeyPress(simulatedEvent);
    }




    const handleKeyPress = async (event) => {
        msgRef.current.focus = true;
        console.log("SENDING...",)
        if (event.key === 'Enter' || event.keyCode == 13) {
            await sleep(200)
            if (msg.length > 0) {
                handleSend(msg)
                msgRef.current.value = ""
                setMsg("")
                setIsEmojiVisible(false)
            }
        }
    }


    const handleEditModal = (e) => {
        console.log(e.target.files[0])

        setMedia(e.target.files[0])
        setImage(URL.createObjectURL(e.target.files[0]))

        handleDesktopModalToggle(true)
    }

    useEffect(() => {
        if (media)
            if (media.type.includes('video')) {
                console.log(videoRef.current)
                videoRef.current.src = window.URL.createObjectURL(media);
            }
    }, [media])

    const handleMediaMsgProcessing = () => {
        handleMediaSend(media, price, monetization)
    }


    const resetModal = () => {
        handleDesktopModalToggle(false)
        setImage("")
        setMedia("")
        setMonitization(-1)
        setPrice(0)
    }

    const toggleEmoji = () => {
        setIsEmojiVisible(!isEmojiVisible)
    }

    const appendEmoji = (e) => {
        console.log(e.native.length)
        msgRef.current.value = msgRef.current.value  + e.native
        setMsg(msgRef.current.value)
    }

    useEffect(() => {
        msgRef.current.focus = false;
    }, [])
    return (
        <div id="chatInputWrapper" className={`${isDark ? 'chat-input-dark' : 'chat-input-light'}`}>

            { isDesktopModalVisible && <div id="chatMediaDesktopModal" className={isDark ? 'chat-modal-dark' : 'chat-modal-light'}>
                <img id="polygon" src={isDark ? require('../../assets/icons/chatmodal_dark.svg') : require('../../assets/icons/chatmodal_light.svg')} />
                <div id="header">
                    <div>
                        <img src={require('../../assets/icons/cam_small.svg')} />
                        <h2>Add media</h2>
                    </div>
                    <img onClick={e => resetModal()} src={require('../../assets/icons/cross_grey.svg')} />
                </div>

                <div id="body">
                    <div id="imageWrapper">
                        <div>
                            {media.type.split('/')[0] == 'image' ? <img src={image} /> : <video ref={videoRef} autoPlay controls muted />}
                            <img onClick={e => resetModal()} id="imageCross" src={require('../../assets/icons/imagecross.svg')} />
                        </div>

                    </div>
                    <div id="mediaType">
                        <Monetization handleMonetization={(e) => setMonitization(e)} />
                        {monetization == 1 && <div id="priceInput">
                            <img src={require('../../assets/icons/chat_modal_dollar.svg')} />
                            <input type="number" onChange={e => setPrice(e.target.value)} />
                        </div>
                        }
                    </div>
                </div>

                {monetization == 0 ? <div id="action">
                    <div onClick={handleMediaMsgProcessing}>
                        <img src={require('../../assets/icons/upload_a.svg')} />
                        <p>{uploadState}</p>
                    </div>
                </div> : (monetization == 1 && price != null && price != undefined && price != 0) ?
                        <div onClick={handleMediaMsgProcessing} id="action">
                            <div>
                                <img src={require('../../assets/icons/upload_a.svg')} />
                                <p>{uploadState}</p>
                            </div>
                        </div>
                        : <div id="action">
                            <div className='grey-colored'>
                                <img src={require('../../assets/icons/upload_a.svg')} />
                                <p>{uploadState}</p>
                            </div>
                        </div>
                }
            </div>}
            
            { isEmojiVisible && <div id="chatEmoji"> <Picker color={'#CA3443'} onSelect={appendEmoji} theme={isDark ? 'dark' : 'light'} set={'twitter'} /> </div>}

            <div id="chatInputRow">
                <div id="chatInputLCol">
                    <div className="chatCTA">
                        <label for="chatMedia">
                            <img src={require('../../assets/icons/camera.svg')} />
                            <input
                                style={{ display: "none" }}
                                onChange={handleEditModal}
                                id="chatMedia"
                                type="file"
                                accept="image/*|video/*"
                            />
                        </label>
                    </div>
                    <div className="chatCTA">
                        <img src={require('../../assets/icons/paid_a.svg')} />
                    </div>
                </div>
                <div id="chatInputCCol">
                    <input autoFocus onKeyPress={handleKeyPress} ref={msgRef} placeholder="Message..." onChange={(e) => setMsg(e.target.value)} />
                </div>
                <div id="chatInputRCol">
                    <img id="emojiToggle" onClick={toggleEmoji} src={isEmojiVisible ? require('../../assets/icons/keyboard.svg') : require('../../assets/icons/emoji.svg')} />
                    <img onClick={simulateEnter} src={require('../../assets/icons/send.svg')} />
                </div>
            </div>
        </div >
    )
}
